const init = function () {
    const pageId = document.querySelector('[data-page="cash_order_form"]');
    if (!pageId) {
        return;
    }
    const routeCalculations = pageId.dataset.routeCalculations;
    const routeInvoices = pageId.dataset.routeInvoices;


    const clientIdInput = document.getElementById('id_klient');
    const clientNameInput = document.getElementById('id_klient_name');
    const hiddenClientName = document.getElementById('Klient');
    const calcClientName = document.getElementById('calc_client_name');
    const invoicesTable = document.querySelector('#invoicesTable tbody');
    const filterButtons = document.querySelectorAll('.filter-btn');
    const sumInput = document.getElementById('Summa');
    const sumGrnInput = document.getElementById('Summa_grn');
    const naznachenieInput = document.getElementById('Naznachenie');

    let currentFilter = {type: 'expense', filter: 'all'};

    // Watch for client changes (from picker)
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                onClientChanged();
            }
        });
    });
    observer.observe(clientIdInput, {attributes: true});

    // Also watch for manual name input sync
    setInterval(() => {
        if (hiddenClientName.value !== clientNameInput.value) {
            hiddenClientName.value = clientNameInput.value;
            calcClientName.textContent = clientNameInput.value || 'Новый клиент';
        }
    }, 500);

    function onClientChanged() {
        const clientId = clientIdInput.value;
        if (!clientId) return;

        loadCalculations(clientId);
        loadInvoices(clientId, currentFilter.type, currentFilter.filter);
    }

    function loadCalculations(clientId) {
        fetch(routeCalculations + `?clientId=${clientId}`)
            .then(res => res.json())
            .then(renderCalculations);
    }

    function renderCalculations(data) {
        document.getElementById('calc_totalSales').textContent = parseFloat(data.totalSales || 0).toFixed(2);
        document.getElementById('calc_totalPurchases').textContent = parseFloat(data.totalPurchases || 0).toFixed(2);
        document.getElementById('calc_clientPaidRN').textContent = parseFloat(data.clientPaidRN || 0).toFixed(2);
        document.getElementById('calc_wePaidPN').textContent = parseFloat(data.wePaidPN || 0).toFixed(2);
        document.getElementById('calc_clientOwesUs').textContent = parseFloat(data.clientOwesUs || 0).toFixed(2);
        document.getElementById('calc_weOweClient').textContent = parseFloat(data.weOweClient || 0).toFixed(2);
        document.getElementById('calc_clientSettledDebt').textContent = parseFloat(data.clientSettledDebt || 0).toFixed(2);
        document.getElementById('calc_weSettledDebt').textContent = parseFloat(data.weSettledDebt || 0).toFixed(2);

        const finalBalance = parseFloat(data.balance ?? ((data.clientOwesUs || 0) - (data.weOweClient || 0)));
        const balanceEl = document.getElementById('calc_final_balance');
        balanceEl.textContent = Math.abs(finalBalance).toFixed(2);

        const labelEl = document.getElementById('calc_balance_label');
        if (finalBalance > 0) {
            labelEl.textContent = 'Долг клиента';
            labelEl.className = 'text-danger small text-uppercase';
            balanceEl.className = 'display-6 fw-bold mb-2 text-danger';
        } else if (finalBalance < 0) {
            labelEl.textContent = 'Наш долг';
            labelEl.className = 'text-success small text-uppercase';
            balanceEl.className = 'display-6 fw-bold mb-2 text-success';
        } else {
            labelEl.textContent = 'Баланс нулевой';
            labelEl.className = 'text-muted small text-uppercase';
            balanceEl.className = 'display-6 fw-bold mb-2 text-muted';
        }
    }

    function loadInvoices(clientId, type, filter) {
        invoicesTable.innerHTML = '<tr><td colspan="11" class="text-center py-5">Загрузка...</td></tr>';

        fetch(routeInvoices + `?clientId=${clientId}&type=${type}&filter=${filter}`)
            .then(res => res.json())
            .then(data => {
                invoicesTable.innerHTML = '';
                data.forEach(inv => {
                    const tr = document.createElement('tr');
                    const statusIcon = inv.Status == 1 ? '<i class="bi bi-check-circle-fill text-success"></i>' : '<i class="bi bi-circle text-muted"></i>';

                    tr.innerHTML = `
                        <td>${statusIcon}</td>
                        <td class="fw-bold">${type === 'expense' ? 'PH' : 'ПН'}-${inv.Nomer}</td>
                        <td>${inv.Data}</td>
                        <td>${inv.Klient}</td>
                        <td class="text-end">${parseFloat(inv.Summa).toFixed(2)}</td>
                        <td class="text-end">${parseFloat(inv.summa_grn).toFixed(2)}</td>
                        <td class="text-end">${parseFloat(inv.Itogo).toFixed(2)}</td>
                        <td class="text-end">${parseFloat(inv.Itogo_grn).toFixed(2)}</td>
                        <td class="text-end text-success">${parseFloat(inv.Oplacheno).toFixed(2)}</td>
                        <td class="text-end text-success">${parseFloat(inv.Oplacheno_grn).toFixed(2)}</td>
                        <td>${inv.Adres || ''}</td>
                        <td class="text-end">${parseFloat(inv.Metall || 0).toFixed(2)}</td>
                        <td class="small text-muted">${inv.Primechanie || ''}</td>
                    `;

                    tr.addEventListener('dblclick', () => {
                        const remaining = inv.Itogo - inv.Oplacheno;
                        const remainingGrn = inv.Itogo_grn - inv.Oplacheno_grn;
                        sumInput.value = remaining.toFixed(2);
                        sumGrnInput.value = remainingGrn.toFixed(2);
                        naznachenieInput.value = `${type === 'expense' ? 'PH' : 'ПН'} ${inv.Nomer}`;
                    });

                    invoicesTable.appendChild(tr);
                });

                if (data.length === 0) {
                    invoicesTable.innerHTML = '<tr><td colspan="13" class="text-center py-5 text-muted">Нет документов</td></tr>';
                }
            });
    }

    filterButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            filterButtons.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            currentFilter.type = btn.dataset.type;
            currentFilter.filter = btn.dataset.filter;

            if (clientIdInput.value) {
                loadInvoices(clientIdInput.value, currentFilter.type, currentFilter.filter);
            }
        });
    });

    window.cashOrderFormReload = () => onClientChanged();
    window.cashOrderFormSetCalculations = renderCalculations;

    // Initial load if editing
    if (clientIdInput.value) {
        onClientChanged();
    }

}

export default {init};
